// The style a Saju manuscript is refused for (specs/011 §5) — only rules the Saju app already keeps, copied here so the
// Studio refuses what the app would (narrative-style.test.mjs keeps the copies equal to their sources):
//   · the wiki's reader-safe language: a dangerous phrase outside a guarding context (a negation, "대신", an example)
//     — services/sajug/scripts/saju_wiki_consistency_audit.py DANGEROUS_PHRASES, SAFE_CONTEXT_MARKERS;
//   · the wealth reports' money rules: a named coin or stock, a guaranteed or certain return, a 100% figure, an order
//     to invest, speculation — services/sajug/web/services/saju_wealth_sections.py _MONEY_FORBID. The app keeps them for
//     its wealth sections, and so does the Studio: for the wealth book's manuscripts. Outside money they misread — of the
//     5,827 manuscripts the sample's books print, two ("확실하게 만들고 싶어지는", "만남을 보장하는 뜻은 아닙니다")
//     trip the guarantee rule and none break the rules where they apply.
// The wiki's FAQ and conversion dictionary describe better sentences by example; they are not a list of phrases.

export const DANGEROUS_PHRASES = Object.freeze(['반드시 사고가 난다', '무조건 나쁘다', '귀인이 없으니 도움을 못 받는다', '충이 있으니 끝난다',
  '기신이 오니 망한다', '없어서 망한다', '돈을 못 버는', '불가능']);
export const SAFE_CONTEXT_MARKERS = Object.freeze(['아니', '않', '보다', '피한다', '바꾼', '바꿔', '금지', '예시', '대신', '하지 않는다',
  '것이 아니', '것도 아니다', '안 된다']);
export const MONEY_FORBID = Object.freeze([
  [/비트코인|이더리움|알트코인|리플|도지/, '구체 코인 지목'],
  [/삼성전자|테슬라|엔비디아|애플|구글|아마존/, '구체 종목 지목'],
  [/(?:(?<![불미])확실|보장)(?![가-힣\s]{0,12}(?:않|없|아니|못))/, '수익 보장 표현'],
  [/반드시\s*(?:큰\s*)?(?:돈|부자|성공|수익|오릅|오른|벌)(?![가-힣\s]{0,12}(?:않|없|아니|못))/, '수익 단정 표현'],
  [/100\s*[%퍼]/, '단정 수치 연출'],
  [/무조건\s*(?:사|매수|투자|벌)/, '투자 지시 표현'],
  [/투기/, "'투기' 표현(판매본 금칙 — '기회형 투자'로 표현)"],
].map(Object.freeze));

// The wiki audit reads a line at a time; a manuscript is a paragraph, so a sentence at a time.
const sentences = text => text.split(/(?<=[.!?。])\s+|\n+/).map(sentence => sentence.trim()).filter(Boolean);

/** The rules a text breaks: [{ rule: 'wiki' | 'money', label, sentence }]; `money` for a wealth manuscript. */
export function styleIssues(text, { money = false } = {}) {
  const issues = [];
  for (const sentence of sentences(text)) {
    const guarded = SAFE_CONTEXT_MARKERS.some(marker => sentence.includes(marker));
    for (const phrase of DANGEROUS_PHRASES) if (!guarded && sentence.includes(phrase)) issues.push({ rule: 'wiki', label: `위험 표현 「${phrase}」`, sentence });
    if (money) for (const [pattern, label] of MONEY_FORBID) if (pattern.test(sentence)) issues.push({ rule: 'money', label, sentence });
  }
  return issues;
}
